<div class="content-padding">
  <div class="restaurants">
    <div class="restaurant" *ngFor="let r of restaurants">
      <app-fold-item [title]="r.name" [isOpen]="restaurant === r" size="big" content="restaurant"
        (triggerItem)="selectRestaurant(r)"></app-fold-item>
      <div class="additional-restaurant-info" *ngIf="restaurant === r">
        <div class="open-hours">
          <p class="title">{{ "OPEN_HOURS" | translate }}</p>
          <div class="details">
            <div class="regular" *ngFor="let o of restaurantOpenHours('regular')">
              <div class="week-day">
                {{ "WEEK_DAY" + o.fromDay | translate
                }}<span *ngIf="o.fromDay !== o.toDay">
                  - {{ "WEEK_DAY" + o.toDay | translate }}</span>:
              </div>
              <div class="times">
                <div class="time" *ngFor="let t of o.times">
                  <span *ngIf="t.openFrom !== t.openTo">
                    {{ formatTime(t.openFrom) }} - {{ formatTime(t.openTo) }}
                    <span class="timeWord">{{ "O_CLOCK" | translate }}</span>
                  </span>
                  <span class="closed" *ngIf="t.openFrom === t.openTo">
                    {{ "CLOSED" | translate }}
                  </span>
                </div>
              </div>
            </div>

            <div class="special" *ngFor="let o of restaurantOpenHours('special'); index as i"
              [style.marginTop]="i === 0 ? '8px' : 0">
              <div class="week-day">
                {{ o.specialDate | date : "dd.MM.yyyy" }}:
              </div>
              <span class="open times" *ngIf="o.openFrom !== o.openTo">
                {{ formatTime(o.openFrom) }} - {{ formatTime(o.openTo) }}
                <span class="timeWord">{{ "O_CLOCK" | translate }}</span>
              </span>
              <span class="closed times" *ngIf="o.openFrom === o.openTo">
                {{ "CLOSED" | translate }}
              </span>
            </div>
            <div class="no-open-hours" *ngIf="restaurantOpenHours('regular')?.length < 1">
              Restaurant has no regular Open Hours
            </div>
            
          </div>
          <div class="note holiday" *ngIf="r.name === 'Andermatt Reuss'" [innerHTML]="'ANDERMATT_SPECIAL_HOURS' | translate"></div>
          <div class="note" *ngIf="r.name !== 'Andermatt Reuss'">
            {{ "OPEN_HOURS_NOTE" | translate }}
          </div>
          <div class="note" *ngIf="r.name === 'Andermatt Reuss'" [innerHTML]="'ANDERMATT_OPEN_HOURS' | translate"></div>
        </div>
        <div class="address">
          <div class="title">{{ r.name }}</div>
          <div class="details">
            <p (click)="openGoogleMaps(r.latitude, r.longitude)" class="multi-line-txt street-city"
              [innerHTML]="r.address | replaceLineBreaks"></p>
            <a href="tel:{{ formatedPhoneNumber }}" class="email">
              <div>
                {{ r.phoneNumber ? r.phoneNumber : "" }}
              </div>
            </a>
            <div (click)="r.email && openEmail(r.email)" class="email">
              {{ r.email ? r.email : "" }}
            </div>
          </div>
          <div class="note" *ngIf="r.name !== 'Andermatt Reuss'">
            {{ "CASHLESS_ONLY" | translate }}
          </div>
        </div>
        
      </div>
    </div>
  </div>
</div>